/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { CMS64Head as originalColumnDefs } from './TableHead';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_620 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  getCmsReportingData,
  getAgencyInfo,
  getFreezeCMSQtrPrtBal,
  dispatchFlag,
  getCmsRebateGroupFindFreezeQtrByRpc
} from '../Store/action';
import { exportPDF } from './ExportPdf';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  API_TIMEOUT_ERROR,
  SUCCESS_MEG_FREEZE_VALUE,
  ERROR_MEG_FREEZE_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

const DisQuarterlyReporting = (props) => {
  const {
    displayObj: {
      groupOfRebateProgramList,
      rebateCategoryValue,
      rebateProgramName: getRebateProgramName,
      selectedOptionValue: getSelectedOptionData,
      startQtr: startQtrValue,
      quarterlyReporting: getReportingData,
      agencyInfo: getAgencyInfoList,
    },
  } = useSelector((state) => state?.sharedState?.CMSQuarterlyReducer);
  const getFlagData = useSelector(
    (state) => state?.sharedState?.CMSQuarterlyReducer?.getFlag
  );
  const rebateGroupFreezeQtr = useSelector(
    (state) => state?.sharedState?.CMSQuarterlyReducer?.rebateGroupFreezeQtr
  );

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = useState(false);
  const [info, setInfo] = useState(false);
  const [open, setOpen] = useState(false);
  const [openfrozen, setOpenFrozen] = useState(false);
  const [openFreezeDiscrepancy, setOpenFreezeDiscrepancy] = useState(false);
  const [freezeDiscrepancyAckKey, setFreezeDiscrepancyAckKey] = useState('');
  const [isFrozen, setIsFrozen] = useState(false);

  const [successMessages, setSuccessMessage] = React.useState([]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  function convertInput(input) {
    const datePattern = /\d{2}\/\d{2}\/\d{4}/;
    const quarterPattern = /\dQ\d{4}/;

    if (datePattern.test(input)) {
      return convertDateRange(input);
    }
    if (quarterPattern.test(input)) {
      return input;
    }
  }
  // converting mm/dd/yyyy to mQyyyy
  function convertDateRange(dateRange) {
    const dates = dateRange.split(' - ');
    const startDate = new Date(dates[0]);

    const startQuarter = Math.floor(startDate.getMonth() / 3 + 1);
    const startYear = startDate.getFullYear();

    const formattedString = `${startQuarter}Q${startYear}`;

    return formattedString;
  }
  const fromRange = convertInput(startQtrValue);
  const [data, setData] = useState([]);
  const [CMS64Head, setCMS64Head] = useState([]);
  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  function getQuarterDates(quarter) {
    const year = parseInt(quarter?.slice(-4));
    const quarterNum = parseInt(quarter?.slice(0, 1));
    let startDate;
    let endDate;

    switch (quarterNum) {
      case 1:
        startDate = new Date(year, 0, 1);
        endDate = new Date(year, 2, 31);
        break;
      case 2:
        startDate = new Date(year, 3, 1);
        endDate = new Date(year, 5, 30);
        break;
      case 3:
        startDate = new Date(year, 6, 1);
        endDate = new Date(year, 8, 30);
        break;
      case 4:
        startDate = new Date(year, 9, 1);
        endDate = new Date(year, 11, 31);
        break;
    }

    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const startStr = startDate?.toLocaleDateString('en-US', options);
    const endStr = endDate?.toLocaleDateString('en-US', options);

    return { startDate: startStr, endDate: endStr };
  }
  const qtr = getQuarterDates(fromRange);

  useEffect(() => {
    if (getReportingData != undefined) {
      setData(getReportingData);
    }

  }, [getReportingData]);
  const claims = [
    '1.Balance as of Beginning of the Quarter',
    '2.Adjustments to Previously Reported Rebates',
    '3.Rebates Established this Quarter',
    '4.Subtotal',
    '5.Rebates Reported on this Expenditure Report',
    '5a.Rebates Reported for MAT Drugs',
    '5b.Rebates Reported for Non MAT Drugs',
    '6.Balances As of the End of the Quarter',
    'Total QROA Change Amount',
    'QROA for MAT Drugs',
    'QROA for Non MAT Drugs',
    'Interest Received',
    'Drug Spend (Reimburse Amounts)',
  ];

  const isFreezeComparisonMode = rebateGroupFreezeQtr?.data === 1;
  const toSafeNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };
  
  const emptyFrozenTotals = () => Array.from({ length: claims.length }, () => 0);
  const buildFrozenTotals = (rawColumn = []) => {
    if (!Array.isArray(rawColumn) || rawColumn.length === 0) return emptyFrozenTotals();

    const rowMap = new Map(
      rawColumn
        .filter((r) => r && r.rowNumber != null)
        .map((r) => [Number(r.rowNumber), toSafeNumber(r.totalDollars)])
    );

    const balanceAmt = rowMap.get(1) ?? 0;
    const adjustmentAmtLN2 = rowMap.get(2) ?? 0;
    const rebatesEstAmtLN3 = rowMap.get(3) ?? 0;
    const paymentsReceivedAmtLN5 = rowMap.get(4) ?? 0;
    const paymentsReceivedAmtLN5Mat = rowMap.get(5) ?? 0;
    const interestReceivedAmt = rowMap.get(6) ?? 0;
    const roaChangeAmt = rowMap.get(7) ?? 0;
    const roaChangeAmtMat = rowMap.get(8) ?? 0;
    const totReimbursedAmtMat = rowMap.get(9) ?? 0;

    const beginBalAmt =
      balanceAmt -
      adjustmentAmtLN2 -
      rebatesEstAmtLN3 +
      paymentsReceivedAmtLN5;
    const subtotal = beginBalAmt + adjustmentAmtLN2 + rebatesEstAmtLN3;
    const paymentsReceivedAmtLN5NonMat =
      paymentsReceivedAmtLN5 - paymentsReceivedAmtLN5Mat;
    const endBalAmt = subtotal - paymentsReceivedAmtLN5;
    const roaChangeAmtNonMat = roaChangeAmt - roaChangeAmtMat;

    return [
      beginBalAmt,
      adjustmentAmtLN2,
      rebatesEstAmtLN3,
      subtotal,
      paymentsReceivedAmtLN5,
      paymentsReceivedAmtLN5Mat,
      paymentsReceivedAmtLN5NonMat,
      endBalAmt,
      roaChangeAmt,
      roaChangeAmtMat,
      roaChangeAmtNonMat,
      interestReceivedAmt,
      totReimbursedAmtMat,
    ];
  };

  const extractColumn = (root, key) => {
    if (!root) return [];
    if (Array.isArray(root?.[key])) return root[key];
    if (Array.isArray(root) && Array.isArray(root?.[0]?.[key])) return root[0][key];
    return [];
  };

  const isDifferentNumber = (a, b) => {
    const na = toSafeNumber(a);
    const nb = toSafeNumber(b);
    return Math.abs(na - nb) > 0.000001;
  };

  const sumResults = (...cols) => {
    if (!cols.length || !cols.every((c) => Array.isArray(c) && c.length)) return [];
    const len = Math.max(...cols.map((c) => c.length));
    const summed = Array.from({ length: len }, (_, i) =>
      cols.reduce((acc, c) => acc + (toSafeNumber(c[i]) ?? 0), 0)
    );
    if (summed.length > 10) summed[10] = (summed[8] ?? 0) - (summed[9] ?? 0);
    return summed;
  };

  const ZERO_RULES = {
    2: ['column2', 'column3', 'column4', 'column5'] 
  };

const normalizeColumn = (column = [], columnKey) => {
  return column.map((item, index) => {
    let value = item?.totalDollars;

    if (value === null || value === undefined) {
      value = 0;
    }

    if (ZERO_RULES[index]?.includes(columnKey)) {
      value = 0;
    }

    return { ...item, totalDollars: value };
  });
};

  const column1 = normalizeColumn(data?.column1, 'column1'); 
  const column2 = normalizeColumn(data?.column2, 'column2');
  const column3 = normalizeColumn(data?.column3, 'column3');
  const column4 = normalizeColumn(data?.column4, 'column4');
  const column5 = normalizeColumn(data?.column5, 'column5');

  const calculateTotals = (column = []) => {
    if (!column.length) return [];

    const get = (i) => column?.[i]?.totalDollars ?? 0;

    return [
      get(0),

      get(1) + get(9) - get(8),

      get(2),

      get(0) + (get(1) + get(9) - get(8)) + get(2),

      get(3) + get(7) + get(10) - get(8),

      get(13) + get(17),

      get(3) + get(7) + get(10) - get(8) - get(13),

      get(0) +
      (get(1) + get(9) - get(8)) +
      get(2) -
      (get(3) + get(7) + get(10) - get(8)),

      get(12),
      get(14),
      get(12) - get(14),

      get(11),
      get(15) + get(16),
    ];
  };

  const result1 = calculateTotals(column1);
const result2 = calculateTotals(column2);
const result3 = calculateTotals(column3);
const result4 = calculateTotals(column4);
const result5 = calculateTotals(column5);

  const rawCmpr1 = extractColumn(data, 'columnCmpr1')
    .slice()
    .sort((a, b) => (a?.rowNumber ?? 0) - (b?.rowNumber ?? 0))
    .slice(0, 9);
  const rawCmpr2 = extractColumn(data, 'columnCmpr2')
    .slice()
    .sort((a, b) => (a?.rowNumber ?? 0) - (b?.rowNumber ?? 0))
    .slice(0, 9);
  const rawCmpr3 = extractColumn(data, 'columnCmpr3')
    .slice()
    .sort((a, b) => (a?.rowNumber ?? 0) - (b?.rowNumber ?? 0))
    .slice(0, 9);
  const rawCmpr4 = extractColumn(data, 'columnCmpr4')
    .slice()
    .sort((a, b) => (a?.rowNumber ?? 0) - (b?.rowNumber ?? 0))
    .slice(0, 9);
  const rawCmpr5 = extractColumn(data, 'columnCmpr5')
    .slice()
    .sort((a, b) => (a?.rowNumber ?? 0) - (b?.rowNumber ?? 0))
    .slice(0, 9);

  const frozenResult1 = buildFrozenTotals(rawCmpr1);
  const frozenResult2 = buildFrozenTotals(rawCmpr2);
  const frozenResult3 = buildFrozenTotals(rawCmpr3);
  const frozenResult4 = buildFrozenTotals(rawCmpr4);
  const frozenResult5 = buildFrozenTotals(rawCmpr5);
  const frozenResult6 = sumResults(
    frozenResult1,
    frozenResult2,
    frozenResult3,
    frozenResult4,
    frozenResult5
  );

  const canRenderFrozen =
    isFreezeComparisonMode &&
    Boolean(rawCmpr1.length || rawCmpr2.length || rawCmpr3.length || rawCmpr4.length || rawCmpr5.length);


let result6 = [];

if (
  result1.length &&
  result2.length &&
  result3.length &&
  result4.length &&
  result5.length
) {
  result6 = result1.map((_, index) =>
    (result1[index] ?? 0) +
    (result2[index] ?? 0) +
    (result3[index] ?? 0) +
    (result4[index] ?? 0) +
    (result5[index] ?? 0)
  );

  // Fix QROA Difference (index 10)
  result6[10] = (result6[8] ?? 0) - (result6[9] ?? 0);
}

  const applyGreyZeroOverrides = (
    result = [],
    { beginBalZero = false, rebatesEstZero = false } = {}
  ) => {
    if (!Array.isArray(result) || !result.length) return result;

    const r = result.map((v) => toSafeNumber(v));

    if (beginBalZero) r[0] = 0;
    if (rebatesEstZero) r[2] = 0;

    if (r.length > 3) r[3] = (r[0] ?? 0) + (r[1] ?? 0) + (r[2] ?? 0);
    if (r.length > 7) r[7] = (r[3] ?? 0) - (r[4] ?? 0);

    return r;
  };

  const frozenDisplay1 = canRenderFrozen
    ? applyGreyZeroOverrides(frozenResult1, { beginBalZero: true })
    : frozenResult1;
  const frozenDisplay2 = canRenderFrozen
    ? applyGreyZeroOverrides(frozenResult2, { rebatesEstZero: true })
    : frozenResult2;
  const frozenDisplay3 = canRenderFrozen
    ? applyGreyZeroOverrides(frozenResult3, { rebatesEstZero: true })
    : frozenResult3;
  const frozenDisplay4 = canRenderFrozen
    ? applyGreyZeroOverrides(frozenResult4, { rebatesEstZero: true })
    : frozenResult4;
  const frozenDisplay5 = canRenderFrozen
    ? applyGreyZeroOverrides(frozenResult5, { rebatesEstZero: true })
    : frozenResult5;
  const frozenDisplay6 = canRenderFrozen
    ? sumResults(
        frozenDisplay1,
        frozenDisplay2,
        frozenDisplay3,
        frozenDisplay4,
        frozenDisplay5
      )
    : frozenResult6;

  const compareResult1 = canRenderFrozen
    ? applyGreyZeroOverrides(result1, { beginBalZero: true })
    : result1;
  const compareResult2 = canRenderFrozen
    ? applyGreyZeroOverrides(result2, { rebatesEstZero: true })
    : result2;
  const compareResult3 = canRenderFrozen
    ? applyGreyZeroOverrides(result3, { rebatesEstZero: true })
    : result3;
  const compareResult4 = canRenderFrozen
    ? applyGreyZeroOverrides(result4, { rebatesEstZero: true })
    : result4;
  const compareResult5 = canRenderFrozen
    ? applyGreyZeroOverrides(result5, { rebatesEstZero: true })
    : result5;
  const compareResult6 = canRenderFrozen
    ? sumResults(
        compareResult1,
        compareResult2,
        compareResult3,
        compareResult4,
        compareResult5
      )
    : result6;

// ==========================================================
// BUILD GRID ROW DATA
// ==========================================================
  const displayColResults = canRenderFrozen
    ? [
        frozenDisplay1,
        frozenDisplay2,
        frozenDisplay3,
        frozenDisplay4,
        frozenDisplay5,
        frozenDisplay6,
      ]
    : [result1, result2, result3, result4, result5, result6];

  const compareColResults = canRenderFrozen
    ? [
        compareResult1,
        compareResult2,
        compareResult3,
        compareResult4,
        compareResult5,
        compareResult6,
      ]
    : null;

  const freezeMismatchExcludedRowLabels = new Set([
    '4.Subtotal',
    '5b.Rebates Reported for Non MAT Drugs',
    'QROA for Non MAT Drugs',
    'Interest Received',
  ]);

  const baseRowData = claims.map((item, index) => {
    const mismatch = {};

    if (compareColResults) {
      const fields = ['field2', 'field3', 'field4', 'field5', 'field6'];
      for (let i = 0; i < fields.length; i++) {
        const f = fields[i];

        if (freezeMismatchExcludedRowLabels.has(item)) {
          continue;
        }

        if (
          item === '3.Rebates Established this Quarter' &&
          (f === 'field3' || f === 'field4' || f === 'field5' || f === 'field6')
        ) {
          continue;
        }

        if (
          item === '1.Balance as of Beginning of the Quarter' &&
          f === 'field2'
        ) {
          continue;
        }

        const displayVal = displayColResults[i]?.[index];
        const compareVal = compareColResults[i]?.[index];
        if (isDifferentNumber(displayVal, compareVal)) mismatch[f] = true;
      }
    }

    const formatted = (arr, idx) =>
      arr?.[idx] !== undefined ? toSafeNumber(arr?.[idx]).toFixed(2) : '0.00';

    const isRow1 = item === '1.Balance as of Beginning of the Quarter';
    const isRow3 = item === '3.Rebates Established this Quarter';

    return {
      field1: item,
      field2: isRow1 ? '' : formatted(displayColResults[0], index),
      field3: isRow3 ? '' : formatted(displayColResults[1], index),
      field4: isRow3 ? '' : formatted(displayColResults[2], index),
      field5: isRow3 ? '' : formatted(displayColResults[3], index),
      field6: isRow3 ? '' : formatted(displayColResults[4], index),
      field7: formatted(displayColResults[5], index),
      __freezeMismatch: mismatch,
    };
  });

  const hasFreezeDiscrepancy = baseRowData.some(
    (r) => r?.__freezeMismatch && Object.keys(r.__freezeMismatch).length > 0
  );

  useEffect(() => {
    const isSearch=sessionStorage.getItem('fromSearch', 'true');
    if(!isSearch) return;
    if (!canRenderFrozen || !hasFreezeDiscrepancy) return;
    const rpc =
      getSelectedOptionData === 'Single'
        ? getRebateProgramName?.rebateProgramCd
        : groupOfRebateProgramList?.[0]?.rebateProgramCode;
    const key = `${startQtrValue || ''}|${rpc || ''}`;
    if (freezeDiscrepancyAckKey === key) return;
    setOpenFreezeDiscrepancy(true);
    setFreezeDiscrepancyAckKey(key);
    sessionStorage.removeItem('fromSearch');
  }, [
    canRenderFrozen,
    hasFreezeDiscrepancy,
    freezeDiscrepancyAckKey,
    startQtrValue,
    getSelectedOptionData,
    getRebateProgramName?.rebateProgramCd,
    groupOfRebateProgramList,
  ]);

  let rowdata1 = baseRowData;

// Insert blank separator row after row 8 (as per your original logic)
rowdata1 = [
  ...rowdata1.slice(0, 8),
  {
    field1: '',
    field2: '',
    field3: '',
    field4: '',
    field5: '',
    field6: '',
    field7: '',
  },
  ...rowdata1.slice(8),
];

  function getPrevQuarterYear(quarter, year) {
    if (quarter === 1) return { quarter: 4, year: year - 1 };
    return { quarter: quarter - 1, year };
  }

  function getQuarterEndDate(quarter, year) {
    const month = quarter * 3;
    const date = new Date(year, month, 0);
    return date.toLocaleDateString('en-US');
  }

  useEffect(() => {
    if (!startQtrValue) return;
    const match = startQtrValue.match(/^(\d)Q(\d{4})$/);
    if (!match) return;
    let [, qStr, yStr] = match;
    let currQuarter = parseInt(qStr, 10);
    let currYear = parseInt(yStr, 10);

    const colInfo = [];

    let tempQuarter = currQuarter;
    let tempYear = currYear;

    for (let i = 0; i < 4; i++) {
      const { quarter: prevQuarter, year: prevYear } = getPrevQuarterYear(
        tempQuarter,
        tempYear
      );

      const dateRange = getQuarterEndDate(tempQuarter, tempYear);

      colInfo.push({
        headerName: `${prevQuarter}Q${prevYear}`,
        dateRange,
      });

      tempQuarter = prevQuarter;
      tempYear = prevYear;
    }

    const modifiedColumnDefs = originalColumnDefs.map((col) => {
      if (col.field === 'field2')
        return {
          ...col,
          headerName: `Quarter Ending (${colInfo[0].dateRange}) ${colInfo[0].headerName}`,
        };
      if (col.field === 'field3')
        return {
          ...col,
          headerName: `Quarter Ending (${colInfo[1].dateRange}) ${colInfo[1].headerName}`,
        };
      if (col.field === 'field4')
        return {
          ...col,
          headerName: `Quarter Ending (${colInfo[2].dateRange}) ${colInfo[2].headerName}`,
        };
      if (col.field === 'field5')
        return {
          ...col,
          headerName: `Quarter Ending (${colInfo[3].dateRange}) ${colInfo[3].headerName}`,
        };
      return col;
    });

    setCMS64Head(modifiedColumnDefs);
  }, [startQtrValue, originalColumnDefs]);
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  useEffect(() => {
    if (!startQtrValue) return;
  
    const rpc =
      getSelectedOptionData === 'Single'
        ? getRebateProgramName?.rebateProgramCd
        : groupOfRebateProgramList?.[0]?.rebateProgramCode;
  
    if (!rpc) return;
  
    dispatch(
      getCmsRebateGroupFindFreezeQtrByRpc({
        quarter: startQtrValue,
        rebateProgramCode: rpc,
      })
    );
  }, [startQtrValue, getSelectedOptionData, getRebateProgramName, groupOfRebateProgramList]);
  React.useEffect(() => {
    if (updateTabs && getFlagData) {
      updateTabs.forEach((item) => {
        if (
          item.navTo === '/DisplayCMSQuarterlyReporting' &&
          item.isPopDisplay && !isFrozen
        ) {
          if (rebateGroupFreezeQtr?.data === 0) {
            setOpenFrozen(true);
          }
          else { customclose(); }

        }
        else if (isFrozen) {
          customclose();
        }
      });
    }
  }, [getFlagData]);
  useEffect(() => {
    dispatch(
      getAgencyInfo({
        rpc:
          getSelectedOptionData === 'Single'
            ? getRebateProgramName?.rebateProgramCd
            : groupOfRebateProgramList?.[0]?.rebateProgramCode,
      })
    );
  }, []);
  const newObj = [...rowdata1];
  console.log(newObj, "test")
  const handleFreezeValues = async () => {
    setErrorMessages([]);
    setSuccessMessage([]);
    setOpen(false);
    setOpenFrozen(false);
    const newObj = [...rowdata1];
    const [quarter, year] = startQtrValue.split('Q');
    const quarterNumber = parseInt(quarter, 10);
    const prevQuarter = quarterNumber === 1 ? 4 : quarterNumber - 1;
    const prevYear = quarterNumber === 1 ? parseInt(year, 10) - 1 : year;
    const headerName1 = `${prevQuarter}Q${prevYear}`;
    const prevQuarter2 = prevQuarter === 1 ? 4 : prevQuarter - 1;
    const prevYear2 = prevQuarter === 1 ? prevYear - 1 : prevYear;
    const headerName2 = `${prevQuarter2}Q${prevYear2}`;
    const prevQuarter3 = prevQuarter2 === 1 ? 4 : prevQuarter2 - 1;
    const prevYear3 = prevQuarter2 === 1 ? prevYear2 - 1 : prevYear2;
    const headerName3 = `${prevQuarter3}Q${prevYear3}`;

    const prevQuarter4 = prevQuarter3 === 1 ? 4 : prevQuarter3 - 1;
    const prevYear4 = prevQuarter3 === 1 ? prevYear3 - 1 : prevYear3;
    const headerName4 = `${prevQuarter4}Q${prevYear4}`;

    const obj = {
      freezeDt: moment().format('MM/DD/YYYY'),
      userId: logInUser,
      qtr: startQtrValue,
      rebateProgramCd:
        getSelectedOptionData === 'Single'
          ? getRebateProgramName?.rebateProgramCd
          : groupOfRebateProgramList?.[0]?.rebateProgramCode,
      currQtRpt: {
        adjustmentAmtLN2: 0,
        balanceAmt: 0,
        interestReceivedAmt: 0,
        paymentReceivedAmtLN5: 0,
        paymentReceivedAmtLN5Mat: 0,
        prevQtr: headerName1,
        rebatesEstAmtLN3: 0,
        roaChangeAmt: 0,
        roaChangeAmtMat: 0,
        totReimbAmtMat: 0,
      },

      fstPriorQrtRpt: {
        adjustmentAmtLN2: 0,
        balanceAmt: 0,
        interestReceivedAmt: 0,
        paymentReceivedAmtLN5: 0,
        paymentReceivedAmtLN5Mat: 0,
        prevQtr: headerName2,
        rebatesEstAmtLN3: 0,
        roaChangeAmt: 0,
        roaChangeAmtMat: 0,
        totReimbAmtMat: 0,
      },
      secPriorQrtRpt: {
        adjustmentAmtLN2: 0,
        balanceAmt: 0,
        interestReceivedAmt: 0,
        paymentReceivedAmtLN5: 0,
        paymentReceivedAmtLN5Mat: 0,
        prevQtr: headerName3,
        rebatesEstAmtLN3: 0,
        roaChangeAmt: 0,
        roaChangeAmtMat: 0,
        totReimbAmtMat: 0,
      },
      thrdPriorQrtRpt: {
        adjustmentAmtLN2: 0,
        balanceAmt: 0,
        interestReceivedAmt: 0,
        paymentReceivedAmtLN5: 0,
        paymentReceivedAmtLN5Mat: 0,
        prevQtr: headerName4,
        rebatesEstAmtLN3: 0,
        roaChangeAmt: 0,
        roaChangeAmtMat: 0,
        totReimbAmtMat: 0,
      },
      frthPriorQrtRpt: {
        adjustmentAmtLN2: 0,
        balanceAmt: 0,
        interestReceivedAmt: 0,
        paymentReceivedAmtLN5: 0,
        paymentReceivedAmtLN5Mat: 0,
        prevQtr: '0000',
        rebatesEstAmtLN3: 0,
        roaChangeAmt: 0,
        roaChangeAmtMat: 0,
        totReimbAmtMat: 0,
      },
    };
    if (newObj?.length > 0) {
      obj.currQtRpt = {
        ...obj.currQtRpt,
        balanceAmt: parseFloat(newObj[7]?.field2),
        adjustmentAmtLN2: parseFloat(newObj[1]?.field2),
        interestReceivedAmt: parseFloat(newObj[12]?.field2),
        paymentReceivedAmtLN5: parseFloat(newObj[4]?.field2),
        paymentReceivedAmtLN5Mat: parseFloat(newObj[5]?.field2),
        rebatesEstAmtLN3: parseFloat(newObj[2]?.field2),
        roaChangeAmt: parseFloat(newObj[9]?.field2),
        roaChangeAmtMat: parseFloat(newObj[10]?.field2),
        totReimbAmtMat: parseFloat(newObj[13]?.field2),
      };
      obj.fstPriorQrtRpt = {
        ...obj.fstPriorQrtRpt,
        balanceAmt: parseFloat(newObj[7]?.field3),
        adjustmentAmtLN2: parseFloat(newObj[1]?.field3),
        interestReceivedAmt: parseFloat(newObj[12]?.field3),
        paymentReceivedAmtLN5: parseFloat(newObj[4]?.field3),
        paymentReceivedAmtLN5Mat: parseFloat(newObj[5]?.field3),
        rebatesEstAmtLN3: parseFloat(newObj[2]?.field3),
        roaChangeAmt: parseFloat(newObj[9]?.field3),
        roaChangeAmtMat: parseFloat(newObj[10]?.field3),
        totReimbAmtMat: parseFloat(newObj[13]?.field3),
      };
      obj.secPriorQrtRpt = {
        ...obj.secPriorQrtRpt,
        balanceAmt: parseFloat(newObj[7]?.field4),
        adjustmentAmtLN2: parseFloat(newObj[1]?.field4),
        interestReceivedAmt: parseFloat(newObj[12]?.field4),
        paymentReceivedAmtLN5: parseFloat(newObj[4]?.field4),
        paymentReceivedAmtLN5Mat: parseFloat(newObj[5]?.field4),
        rebatesEstAmtLN3: parseFloat(newObj[2]?.field4),
        roaChangeAmt: parseFloat(newObj[9]?.field4),
        roaChangeAmtMat: parseFloat(newObj[10]?.field4),
        totReimbAmtMat: parseFloat(newObj[13]?.field4),
      };
      obj.thrdPriorQrtRpt = {
        ...obj.thrdPriorQrtRpt,
        balanceAmt: parseFloat(newObj[7]?.field5),
        adjustmentAmtLN2: parseFloat(newObj[1]?.field5),
        interestReceivedAmt: parseFloat(newObj[12]?.field5),
        paymentReceivedAmtLN5: parseFloat(newObj[4]?.field5),
        paymentReceivedAmtLN5Mat: parseFloat(newObj[5]?.field5),
        rebatesEstAmtLN3: parseFloat(newObj[2]?.field5),
        roaChangeAmt: parseFloat(newObj[9]?.field5),
        roaChangeAmtMat: parseFloat(newObj[10]?.field5),
        totReimbAmtMat: parseFloat(newObj[13]?.field5),
      };
      obj.frthPriorQrtRpt = {
        ...obj.frthPriorQrtRpt,
        balanceAmt: parseFloat(newObj[7]?.field6),
        adjustmentAmtLN2: parseFloat(newObj[1]?.field6),
        interestReceivedAmt: parseFloat(newObj[12]?.field6),
        paymentReceivedAmtLN5: parseFloat(newObj[4]?.field6),
        paymentReceivedAmtLN5Mat: parseFloat(newObj[5]?.field6),
        rebatesEstAmtLN3: parseFloat(newObj[2]?.field6),
        roaChangeAmt: parseFloat(newObj[9]?.field6),
        roaChangeAmtMat: parseFloat(newObj[10]?.field6),
        totReimbAmtMat: parseFloat(newObj[13]?.field6),
      };
    }
    const result = await dispatch(getFreezeCMSQtrPrtBal(obj));
    setTimeout(async () => {
    setSuccessMessage([]);
    await dispatch(
    getCmsRebateGroupFindFreezeQtrByRpc({
      quarter: startQtrValue,
      rebateProgramCode: getRebateProgramName?.rebateProgramCd,
    })
  );
  await dispatch(
    getCmsReportingData({
      quarter: startQtrValue,
      rebateProgram: [getRebateProgramName?.rebateProgramCd],
    })
  );
}, 2000); 
    if (result === 'failed') {
      handleScrollToEvent();

      setErrorMessages([API_TIMEOUT_ERROR]);
    } else if (
      typeof result === 'string' &&
      result?.includes('A new CMS_FREEZE row is')
    ) {
      setSuccessMessage([SUCCESS_MEG_FREEZE_VALUE]);
      handleScrollToEvent();
    } else {
      setErrorMessages([ERROR_MEG_FREEZE_VALUE]);
      handleScrollToEvent();
    }
  };
  useEffect(() => {
    setInfo(getAgencyInfoList?.substanceAbuseDrugAgencyInfoVO);
  }, [getAgencyInfoList]);

  const federal = info?.cms64AgencyName;
  const dataArray = federal?.split(' ') ?? [];
  const firstData = dataArray[0];

  const customPDFExport = (fname) => {
    const fileName = fname || 'CMS Quarterly Report';
    const columns = CMS64Head.filter((item) => item.field !== '');
    exportPDF(
      rowdata1,
      userDefaults,
      columns,
      getRebateProgramName,
      fileName,
      info?.shortDescription,
      logInUser,
      `${getSelectedOptionData === 'Single'
        ? `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`
        : rebateCategoryValue
      }`,
      dispatch
    );
  };
  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';

  firstInfo = `Adjustments between: ${`${qtr.startDate}-${qtr.endDate}`}`;
  secondInfo = `Period: ${startQtrValue}`;
  thirdInfo = `${getSelectedOptionData === 'Single'
      ? `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`
      : rebateCategoryValue
    }`;
  const customclose = (fname) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const filtered = updateTabs.filter((item) => {
      return item.value !== "Display Summary Report CMS64";
    });
    localStorage.setItem('tabItemsData', JSON.stringify(filtered));
    if (filtered.length > 0) {
      props.history.push({
        pathname: filtered[filtered.length - 1]?.navTo,
        state: filtered[filtered.length - 1]?.state,
      });
    } else {
      props.history.push({
        pathname: '/dashboard',
      });
    }

  };

  return (
    <div className="tBillPanel custom-check  tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Summary Report CMS64"
        parent2="Display Summary Report CMS64"
      />{' '}
      <DisplaySuccessMessages successMessages={successMessages} />
      {errorMessages && errorMessages.length > 0 && (
        <DisplayErrorMessages errorMessages={[...new Set(errorMessages)]} />
      )}
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <p> CMS64 9r</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Rebate_Program"
                      label={
                        getSelectedOptionData === 'Single'
                          ? 'Rebate Program '
                          : 'Group'
                      }
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Rebate_Program' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        getSelectedOptionData === 'Single'
                          ? `${getRebateProgramName?.rebateProgramCd} | ${getRebateProgramName?.shortDescr}`
                          : rebateCategoryValue
                      }
                      disabled
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      label="State"
                      id="State"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'State' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={info?.shortDescription}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      label="Agency"
                      id="Agency"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Agency' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={info?.cms64AgencyName}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      label="Requested Quarter "
                      id="Quarter"
                      fullWidth
                      placeholder=""
                      inputProps={{ id: 'Quarter' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={startQtrValue}
                    />
                  </div>
                  {rebateGroupFreezeQtr?.data > 0 && (
                    <div className="pos-relative">
                      <div className="frozen-text">Frozen</div>{' '}
                    </div>
                 )}
                </div>
              </div>
            </div>
          </>
        )}
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGridWithFeatures
            data-testid="Summary-Report-CMS64"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            isScrollOn
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_620}
            freezeDisabled={
              rebateGroupFreezeQtr?.data > 0 ||
              !checkActionAccessByRole(process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE, kcRoles)
            }
            rowData={rowdata1}
            columnDefs={CMS64Head}
            handleFreezeValuesPopup={() => {
              setOpen(true);
              setErrorMessages([]);
              setSuccessMessage([]);
            }}
            exportFile
            animateRows
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            frameworkComponents={{
              TextBoxRender: (cellInfo) => {
                const name = cellInfo?.value;
                if (name && name.length > 25) {
                  return (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                    >
                      <div>{name}</div>
                    </OverlayTrigger>
                  );
                }
                return <div>{name}</div>;
              },
            }}
            noGlobalSort
            sideBar={false}
            fileName="CMS Quarterly Report"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            // pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo }}
            customPDFExport={customPDFExport}
          />
        </div>
      </div>
      <CommonModal
        open={open}
        className="dialogPanel custom-check dialog-420 common-popup"
        data-testid="common-modal-recal-units-act-2"
        viewAction
        viewHeader
        modalTitle="Display CMS Quarterly Report"
        okTitle="Ok"
        closeTitle="Cancel"
        removeClassName
        childrenComponent={
          <div className="p-3">
            <p>
              You are about to save the data on this report and declare it to be
              the final, official set of data for the quarter. Once you have
              done this, you will not be able to repeat this action later. Any
              changes to payments after this point will be reflected in the
              quarter in which they occur, independent of the receipt date of
              the checks.
            </p>
            <p>
              You may either:
              <br />
              Freeze the data for this quarter (click OK) or Continue working
              with the quarter (click Cancel)
            </p>
          </div>
        }
        onOk={() => {
          handleFreezeValues();
        }}
        onClose={() => {
          dispatch(dispatchFlag(false));
          setOpen(false);
          setErrorMessages([]);
          setSuccessMessage([]);
          customclose();

        }}
      />
      <CommonModal
        className="dialogPanel custom-check dialog-420 common-popup"
        data-testid="common-modal-warning"
        open={openfrozen}
        viewAction
        viewHeader
        onOk={() => {
          dispatch(dispatchFlag(false));
          setIsFrozen(true);
          handleFreezeValues();
          setOpenFrozen(false);

        }}
        onClose={() => {
          setOpenFrozen(false);
          dispatch(dispatchFlag(false));
        }}
        onCancel={() => {
          setOpenFrozen(false);
          dispatch(dispatchFlag(false));
        }}
        onNo={() => {
          dispatch(dispatchFlag(false));
          setOpenFrozen(false);
          setErrorMessages([]);
          setSuccessMessage([]);
          customclose();
        }}

        okTitle="Yes"
        closeTitle="Cancel"
        noTitle="No"
        modalTitle="Display CMS Quarterly Report"
        childrenComponent={
          <div className="p-3">
            <p>
              The Data for this Quarter has not been frozen,so changes to
              payments during this quarter may not be handled correctly.Do u
              want to freeze the data?
            </p>
          </div>
        }
      />
      <CommonModal
        open={openFreezeDiscrepancy}
        className="dialogPanel custom-check dialog-420 common-popup"
        viewAction
        viewHeader
        modalTitle="Display CMS Quarterly Report"
        okTitle="Ok"
        removeClassName
        childrenComponent={
          <div className="p-3">
            <p>
              Data being displayed represents the data which existed when this
              quarter was frozen. The data for the quarter has be recalculated
              and at least one result does not agree with what has been stored.
              Cells with discrepency have been colorized.
            </p>
          </div>
        }
        onOk={() => {
          setOpenFreezeDiscrepancy(false);
        }}
        onClose={() => {
          setOpenFreezeDiscrepancy(false);
        }}
      />
    </div>
  );
};

export default DisQuarterlyReporting;
